module.exports = __webpack_public_path__ + "acad9df90b4ac790162442fe2de03af4.svg";